// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Toolbar_color__1V-4I {\n  color: var(--background-creneau-normal);\n}\n.Toolbar_button__1sLvX {\n  padding: 12px;\n  font-weight: 700;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Toolbar/Toolbar.module.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".color {\n  color: var(--background-creneau-normal);\n}\n.button {\n  padding: 12px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": "Toolbar_color__1V-4I",
	"button": "Toolbar_button__1sLvX"
};
export default ___CSS_LOADER_EXPORT___;
